import axios from 'axios'
import library from '../../../utils/Library'

export const updateUserStatusDeletedOrganizationCorpEntities = async (
  userId
) => {
  const TOKEN = sessionStorage.getItem('token')

  const URL =
    library.getBaseAPIUrl('organization') +
    '/updateUserOrganizationCorpEntities'

  return await axios({
    url: URL,
    method: 'POST',
    headers: {
      Authorization: `Bearer ${TOKEN}`
    },
    data: {
      organizationUserId: userId,
      userStatusCode: 'DELETED'
    }
  })
}
